import {ArticlePartContent} from "@/model/Article";
import {Image} from "@/model/Scrapper";
import {stripTagsAndEntities} from "@/utils/string";

function normalizeChromeText(value: string): string {
    return stripTagsAndEntities(value)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
}

export function isChromeHeading(value: string | null | undefined): boolean {
    const text = normalizeChromeText(value || '');
    if (!text) {
        return false;
    }
    return text === 'outperform your search competitors'
        || text.startsWith('outperform your search competitors ');
}

export function isChromeImage(image: Pick<Image, 'url' | 'alt'> | null | undefined): boolean {
    if (!image) {
        return false;
    }
    if (isChromeHeading(image.alt)) {
        return true;
    }
    const url = String(image.url || '').toLowerCase();
    if (!url) {
        return false;
    }
    return /\/(banners?|popups?|modals?)\//.test(url)
        || url.includes('toolkit-popup')
        || url.includes('/popup/')
        || url.includes('popup-');
}

export function isChromeArticleBlock(block: Pick<ArticlePartContent, 'h' | 'p'> | null | undefined): boolean {
    if (!block) {
        return false;
    }
    return isChromeHeading(block.h) || isChromeHeading(block.p);
}

export function previewImages(images: Image[] | null | undefined): Image[] {
    return (images || []).filter(image => !isChromeImage(image));
}
